export const PATH_SEARCH_FOR_PRODUCTS = '/search-form';
export const PATH_SEARCH_RESULTS = '/search-results';
export const PATH_LOCK_SUMMARY = '/lock-summary';
export const PATH_LOGIN = '/login';
export const PATH_LOCK_EXTENSION = '/lock-extension';

// Scenario routes
export const PATH_SCENARIO = '/Scenario';
export const PATH_SCENARIO_CHANNEL = '/Scenario/Channel';
export const PATH_SCENARIO_SEARCH = '/Scenario/Search';
export const PATH_SCENARIO_RESULTS = '/Scenario/Results';
export const PATH_SCENARIO_SUMMARY = '/Scenario/Summary';

// Debug (Tech Ops) routes
export const PATH_DEBUG = '/debug';
export const PATH_DEBUG_SEARCH = '/debug/search';
export const PATH_DEBUG_RESULTS = '/debug/results';
export const PATH_DEBUG_SUMMARY = '/debug/summary';
